// extracted by mini-css-extract-plugin
export default {"principal":"Principal_principal__q-n3+","aside":"Principal_aside__HyCk6","main":"Principal_main__4NZ-H"};